import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/main.tsx';
import { DeleteIntegrationsRequest } from '@/types/request/DeleteIntegrationsRequest';

const useIntegrationDelete = () => {
  const client = supabaseClient;

  const mutationFn = async (request: DeleteIntegrationsRequest) => {
    return deleteIntegration(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['integrations'] });
    },
  });
};

export default useIntegrationDelete;

async function deleteIntegration(client: SupabaseClient, request: DeleteIntegrationsRequest): Promise<void> {
  const { error } = await client.from('integrations').delete().in('id', request.ids);

  if (error) throw new Error(error.message);

  return;
}
